import ReactOnRails from 'react-on-rails'

import AdminApp from '../bundles/AdminApp'
import CustomerApp from '../bundles/CustomerApp'

ReactOnRails.register({AdminApp, CustomerApp})
